// Downscale a photo in the browser before upload. Camera originals run 7-11 MB;
// a 2000px JPEG at q0.85 is a few hundred KB and looks the same on screen.
// Returns the original file untouched if it is already small enough or the
// browser can't decode it (e.g. HEIC outside Safari).
export const resizeImage = async (file, maxEdge, quality = 0.85) => {
  let bitmap;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  } catch (err) {
    console.warn('⚠️ Could not decode image for resizing; uploading original.', err);
    return file;
  }

  const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
  if (scale === 1 && file.type === 'image/jpeg') {
    bitmap.close();
    return file;
  }

  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, 'image/jpeg', quality)
  );
  return blob || file;
};

// Display size for the gallery lightbox, and a thumbnail for grids.
export const FULL_MAX_EDGE = 2000;
export const THUMB_MAX_EDGE = 640;
